import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import ContainerList from '../../components/Entity/Container/List/List';

const ContainerPage = () => {
  return <Layout > 
       <ContainerList isArchive={false} isDelete={false} ></ContainerList>  
  </Layout>;
}

export default ContainerPage;